// /* PurchaseOrderSellPricesModal.tsx */
// import { useEffect, useMemo, useRef, useState } from 'react';
// import Decimal from 'decimal.js';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import { CardHeader, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import NoData from '@components/NoData/NoData';
// import NeatixModal from '@components/Modal/NeatixModal';

// import type { ItemsWithUomQueryParams, ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import { lookupItemsWithUomRowsByItemIds, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
// import { useTaxTypeList } from '@hooks/Finance/TaxRate/useTaxTypeList';
// import Loading from '@components/Shared/Loader/Loading';

// type Props = {
//   show: boolean;
//   //   setShow: (v: boolean) => void;
//   setShow: any;

//   /** نفس params اللي في POLines (لا نعمل hook جديد) */
//   params?: ItemsWithUomQueryParams;

//   /** نفس itemType اللي في POLines (مثلاً 'Purchasing' أو حسب نظامكم) */
//   priceListId: string | null;

//   /** بنود أمر الشراء */
//   poLines: any[];

//   /** عند الحفظ: نرجّع فقط التغييرات */
//   onSave?: (changes: any[]) => Promise<void> | void;

//   /** تعطيل حفظ/تحميل من الخارج (اختياري) */
//   disabled?: boolean;
// };

// type PriceMode = 'excl' | 'incl';

// const D = (v: Decimal.Value) => new Decimal(v ?? 0);
// const roundView2 = (n: Decimal.Value) => D(n).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
// const roundStore6 = (n: Decimal.Value) => D(n).toDecimalPlaces(6, Decimal.ROUND_HALF_UP).toNumber();

// const clampDecimals = (value: string, maxDec = 6) => {
//   let s = (value ?? '').replace(',', '.').replace(/[^\d.]/g, '');
//   if (s.startsWith('.')) s = `0${s}`;

//   const parts = s.split('.');
//   const intPart = parts[0] ?? '';
//   const decPart = parts.slice(1).join('');

//   if (parts.length === 1) return intPart;
//   return `${intPart}.${decPart.slice(0, maxDec)}`;
// };

// const toInclView = (excl: number, ratePct: number) => {
//   const factor = D(1).plus(D(ratePct).div(100));
//   return roundView2(D(excl).mul(factor));
// };

// const toExclStore = (incl: number, ratePct: number) => {
//   const factor = D(1).plus(D(ratePct).div(100));
//   if (factor.isZero()) return 0;
//   return roundStore6(D(incl).div(factor));
// };

// const fieldKey = (rowKey: string, mode: PriceMode) => `${rowKey}|${mode}`;

// const getLineUomKey = (line: any) =>
//   String(
//     line?.unitOfMeasure ??
//       line?.uomCode ??
//       line?.unitOfMeasureCode ??
//       line?.uom ??
//       line?.unitOfMeasureName ??
//       line?.unitOfMeasureName2 ??
//       ''
//   );

// const getLinePurchasePrice = (line: any) => {
//   const n = Number(
//     line?.unitPrice ?? line?.purchasePrice ?? line?.price ?? line?.unitCost ?? line?.cost ?? line?.costPrice ?? 0
//   );
//   return Number.isFinite(n) ? n : 0;
// };

// /** ✅ قراءة سعر البيع من lookup row (عدّل الـ fallback حسب حقل الباك اند عندكم لو احتجت) */
// const getRowSellExcl = (r: any) => {
//   const n = Number(r?.unitPrice ?? r?.sellPriceExcl ?? r?.sellPrice ?? r?.salesPrice ?? r?.price ?? 0);
//   return Number.isFinite(n) ? n : 0;
// };

// const getRowTaxCategory = (r: any) => {
//   const raw = String(r?.tax ?? r?.taxCategory ?? '').trim();
//   return raw ? raw.toUpperCase() : 'STANDARD';
// };

// const same6 = (a: number, b: number) => roundStore6(a) === roundStore6(b);

// const PurchaseOrderSellPricesModal = ({ show, setShow, priceListId, poLines, onSave, disabled }: Props) => {
//   const { t, i18n } = useTranslation();

//   const abortRef = useRef<AbortController | null>(null);

//   const [loading, setLoading] = useState(false);
//   const [loadError, setLoadError] = useState<any>(null);

//   // ✅ سويتش: التحرير شامل/غير شامل
//   const [editInclVat, setEditInclVat] = useState(true);

//   // ✅ lookup rows + map
//   const [rows, setRows] = useState<ItemWithUomRow[]>([]);
//   const detailsMap = useMemo(() => {
//     const m = new Map<string, ItemWithUomRow>();
//     (rows ?? []).forEach(r => {
//       if (!r?.itemId || !r?.unitOfMeasure) return;
//       m.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
//     });
//     return m;
//   }, [rows]);

//   // ✅ Tax rates (Sales)
//   const { taxList } = useTaxTypeList('Sales');
//   const taxRateMap = useMemo(() => {
//     const m: Record<string, number> = {};
//     (taxList ?? []).forEach((x: any) => {
//       const cat = String(x?.taxCategory ?? '').toUpperCase();
//       const rate = Number(x?.taxRate);
//       if (cat) m[cat] = Number.isFinite(rate) ? rate : 0;
//     });
//     return m;
//   }, [taxList]);

//   const getItemTaxRatePct = (r: any) => {
//     const cat = getRowTaxCategory(r);
//     const found = taxRateMap[cat];
//     if (Number.isFinite(found)) return found;

//     // fallback STANDARD
//     if (cat === 'STANDARD') return 15;
//     return 0;
//   };

//   // ✅ نبني list البنود “كما هي في PO” (line + detailsRow إن وجد)
//   const displayLines = useMemo(() => {
//     const list = (poLines ?? []).filter(l => !!l?.itemId);

//     // محاولة مطابقة تفاصيل الـ lookup للـ line
//     const withDetails = list.map(line => {
//       const uomKey = getLineUomKey(line);

//       // 1) match by makeDetailsKey(itemId, unitOfMeasureCode)
//       const k = makeDetailsKey(line.itemId, uomKey);
//       let det = detailsMap.get(k);

//       // 2) fallback by uomId (لو PO line يخزن uomId والـ lookup يخزن uomId)
//       if (!det && line?.unitOfMeasureId) {
//         det =
//           (rows ?? []).find(
//             r =>
//               String(r?.itemId) === String(line.itemId) &&
//               String((r as any)?.uomId ?? (r as any)?.unitOfMeasureId) === String(line.unitOfMeasureId)
//           ) ?? undefined;
//       }

//       // 3) fallback by unitOfMeasureId on row
//       if (!det && line?.uomId) {
//         det =
//           (rows ?? []).find(
//             r =>
//               String(r?.itemId) === String(line.itemId) &&
//               String((r as any)?.uomId ?? (r as any)?.unitOfMeasureId) === String(line.uomId)
//           ) ?? undefined;
//       }

//       return { line, details: det };
//     });

//     return withDetails;
//   }, [poLines, detailsMap, rows]);

//   // ✅ initial + draft map لسعر البيع (Excl stored 6dp)
//   const [initialMap, setInitialMap] = useState<Record<string, number>>({});
//   const [draftMap, setDraftMap] = useState<Record<string, number>>({});

//   // ✅ input map للنص أثناء التحرير
//   const [priceInputMap, setPriceInputMap] = useState<Record<string, string>>({});

//   const hasChanges = useMemo(() => {
//     for (const k of Object.keys(draftMap)) {
//       if (!same6(draftMap[k], initialMap[k])) return true;
//     }
//     return false;
//   }, [draftMap, initialMap]);

//   // ✅ تحميل lookup rows عند فتح المودال
//   useEffect(() => {
//     if (!show) return;

//     setLoadError(null);
//     setRows([]);
//     setInitialMap({});
//     setDraftMap({});
//     setPriceInputMap({});

//     abortRef.current?.abort();
//     abortRef.current = new AbortController();

//     const itemIds = Array.from(new Set((poLines ?? []).map(l => String(l?.itemId ?? '')).filter(Boolean)));
//     if (!itemIds.length) return;

//     (async () => {
//       try {
//         setLoading(true);

//         const queryParams: any = {
//           PriceListId: priceListId,
//           Scope: 1,
//           WithLastPrice: true
//           //   ...(invId ? { InventoryId: invId } : {}) // ✅ أضفها فقط إذا موجودة
//         };

//         const fetched = await lookupItemsWithUomRowsByItemIds({
//           params: queryParams,
//           itemType: '',
//           itemIds,
//           opts: {
//             signal: abortRef.current?.signal,
//             cache: true,
//             dedupeInFlight: true
//           }
//         });

//         setRows(fetched ?? []);

//         // ✅ نبني initialMap/draftMap حسب بنود PO (key=itemId|unitOfMeasure)
//         const init: Record<string, number> = {};
//         (poLines ?? [])
//           .filter(l => !!l?.itemId)
//           .forEach(l => {
//             const uomKey = getLineUomKey(l);
//             const key = makeDetailsKey(l.itemId, uomKey);

//             // حاول match مباشر
//             let det = (fetched ?? []).find(r => makeDetailsKey(r?.itemId, r?.unitOfMeasure) === key);

//             // fallback by uomId
//             if (!det && l?.unitOfMeasureId) {
//               det =
//                 (fetched ?? []).find(
//                   r =>
//                     String(r?.itemId) === String(l.itemId) &&
//                     String((r as any)?.uomId ?? (r as any)?.unitOfMeasureId) === String(l.unitOfMeasureId)
//                 ) ?? undefined;
//             }

//             // إذا ما وجدنا تفاصيل: نخلي السعر 0 (وقتها يظهر تنبيه في الصف)
//             const sellExcl = det ? roundStore6(getRowSellExcl(det)) : 0;
//             init[key] = sellExcl;
//           });

//         setInitialMap(init);
//         setDraftMap(init);
//       } catch (e: any) {
//         if (String(e?.name) === 'AbortError') return;
//         setLoadError(e);
//       } finally {
//         setLoading(false);
//       }
//     })();

//     return () => abortRef.current?.abort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [show]);

//   // ✅ عند الإغلاق: abort
//   useEffect(() => {
//     if (!show) abortRef.current?.abort();
//   }, [show]);

//   const close = () => setShow(false);

//   const handleSave = async () => {
//     if (disabled) return;
//     if (!hasChanges) return;

//     // ✅ نرجّع فقط المتغيرات
//     const changes: any[] = [];

//     // نلف على “المعروض” (كل بنود PO) وليس فقط الفلترة
//     displayLines.forEach(({ line, details }) => {
//       const uomKey = getLineUomKey(line);
//       const k = makeDetailsKey(line.itemId, uomKey);

//       const next = draftMap[k] ?? 0;
//       const prev = initialMap[k] ?? 0;

//       if (!same6(next, prev)) {
//         changes.push({
//           lineId: String(line?.id ?? line?.lineId ?? ''),
//           itemId: String(line.itemId),
//           unitOfMeasure: String(uomKey),
//           sellPriceExcl: roundStore6(next)
//         });
//       }
//     });

//     if (!changes.length) return;

//     try {
//       setLoading(true);
//       await onSave?.(changes);

//       // ✅ بعد نجاح الحفظ: نعتبر draft هو الجديد
//       setInitialMap(prev => {
//         const next = { ...prev };
//         changes.forEach(c => {
//           const k = makeDetailsKey(c.itemId, c.unitOfMeasure);
//           next[k] = roundStore6(c.sellPriceExcl);
//         });
//         return next;
//       });
//       setDraftMap(prev => {
//         const next = { ...prev };
//         changes.forEach(c => {
//           const k = makeDetailsKey(c.itemId, c.unitOfMeasure);
//           next[k] = roundStore6(c.sellPriceExcl);
//         });
//         return next;
//       });

//       close();
//     } catch (e: any) {
//       setLoadError(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ UI classes (نفس أسلوبك)
//   const priceBaseClass = 'form-control form-control-sm text-center border border-2 bg-body fw-bold';
//   const priceActiveClass = 'text-theme border-theme';
//   const priceInactiveClass = 'bg-secondary bg-opacity-10 border-secondary text-muted';

//   const title = 'أسعار البيع لبنود أمر الشراء';

//   return (
//     <NeatixModal show={show} setShow={setShow} showHeader={false} bodyClassName='p-0' size='xl'>
//       <Loading loading={loading} error={loadError}>
//         <Card className='w-100 d-flex flex-column' style={{ height: '75vh' }}>
//           <CardHeader className='fw-bold small bg-info bg-opacity-25'>
//             <div className='d-flex justify-content-between align-items-center gap-2'>
//               <div className='d-flex align-items-center gap-2'>
//                 <h6 className='m-1'>{title}</h6>
//                 <span className='badge bg-dark bg-opacity-10 text-muted'>{editInclVat ? ' شامل' : 'غير شامل'}</span>
//               </div>

//               <Form.Check
//                 type='switch'
//                 id='po-sellprices-editInclVat'
//                 className='mb-0'
//                 label={editInclVat ? ' شامل الضريبة' : ' بدون ضريبة'}
//                 checked={editInclVat}
//                 onChange={e => {
//                   setEditInclVat(e.target.checked);
//                   setPriceInputMap({});
//                 }}
//                 disabled={disabled || loading}
//               />
//             </div>
//           </CardHeader>

//           <CardBody className='d-flex flex-column flex-grow-1' style={{ minHeight: 0 }}>
//             {/* ✅ الجدول */}
//             <div className='flex-grow-1' style={{ minHeight: 0 }}>
//               {displayLines.length > 0 ? (
//                 <div className='table-responsive h-100' style={{ overflowY: 'auto' }}>
//                   <table className='table table-hover mb-0' style={{ tableLayout: 'fixed', width: '100%' }}>
//                     <colgroup>
//                       <col style={{ width: '45%' }} />
//                       <col style={{ width: '10%' }} />
//                       <col style={{ width: '15%' }} />
//                       <col style={{ width: '15%' }} />
//                     </colgroup>

//                     <thead
//                       className='small text-muted sticky-top bg-theme bg-opacity-25'
//                       style={{
//                         backdropFilter: 'blur(20px)',
//                         backgroundColor: 'rgba(var(--bs-body-bg-rgb), 0.0)'
//                       }}
//                     >
//                       <tr>
//                         <th>الصنف</th>

//                         <th className='text-center'>سعر الشراء</th>
//                         <th className='text-center'>بيع غير شامل</th>
//                         <th className='text-center'>بيع شامل</th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {displayLines.map(({ line, details }, idx) => {
//                         const uomKey = getLineUomKey(line);
//                         const rowKey = makeDetailsKey(line.itemId, uomKey);

//                         const purchase = getLinePurchasePrice(line);

//                         const detName = details?.name2 ?? details?.name;
//                         const lineName = line?.name2 ?? line?.name;

//                         const itemName = String(detName ?? lineName ?? '').trim() || '-';
//                         const itemCode = String(details?.itemCode ?? line?.itemCode ?? line?.code ?? '').trim();

//                         const uomName =
//                           i18n.language === 'en'
//                             ? String((details as any)?.unitOfMeasureName ?? line?.unitOfMeasureName ?? uomKey ?? '')
//                             : String((details as any)?.unitOfMeasureName2 ?? line?.unitOfMeasureName2 ?? uomKey ?? '');

//                         const ratePct = details ? getItemTaxRatePct(details) : 15; // fallback
//                         const taxCat = details ? getRowTaxCategory(details) : 'STANDARD';
//                         const taxTitle = `Tax: ${taxCat} (${ratePct}%)`;

//                         const baseExcl = roundStore6(draftMap[rowKey] ?? 0);

//                         // ✅ أي عمود قابل للتحرير؟
//                         const exclReadOnly = editInclVat;
//                         const inclReadOnly = !editInclVat;

//                         // ✅ displayed values (نص)
//                         const displayedExcl = (() => {
//                           const k = fieldKey(rowKey, 'excl');
//                           if (priceInputMap[k] !== undefined) return priceInputMap[k];
//                           return roundView2(baseExcl).toFixed(2);
//                         })();

//                         const displayedIncl = (() => {
//                           const k = fieldKey(rowKey, 'incl');
//                           if (priceInputMap[k] !== undefined) return priceInputMap[k];
//                           return toInclView(Number(baseExcl), ratePct).toFixed(2);
//                         })();

//                         const missingDetails = !details;

//                         return (
//                           <tr key={rowKey || idx}>
//                             <td className='align-middle'>
//                               <div className='d-flex justify-content-between align-items-start' style={{ gap: 10 }}>
//                                 <div style={{ minWidth: 0 }}>
//                                   <div className='fw-bold' title={itemName}>
//                                     {itemName}
//                                   </div>
//                                   {itemCode ? <div className='small text-muted'>{itemCode}</div> : null}

//                                   {missingDetails ? (
//                                     <div className='small text-danger'>
//                                       * لم يتم العثور على تفاصيل الصنف/الوحدة من lookup (تأكد من تطابق unitOfMeasure).
//                                     </div>
//                                   ) : null}
//                                 </div>

//                                 <span className='text-theme' style={{ whiteSpace: 'nowrap' }}>
//                                   {uomName || uomKey || '-'}
//                                 </span>
//                               </div>
//                             </td>

//                             <td className='text-center align-middle'>
//                               {/* <span className='fw-bold small'>{roundView2(purchase).toFixed(2)}</span> */}
//                               <span className='fw-bold small'>{(purchase)}</span>
//                             </td>

//                             {/* ✅ بيع غير شامل */}
//                             <td className='align-middle'>
//                               <Form.Control
//                                 className={[priceBaseClass, exclReadOnly ? priceInactiveClass : priceActiveClass].join(
//                                   ' '
//                                 )}
//                                 type='text'
//                                 inputMode='decimal'
//                                 autoComplete='off'
//                                 value={displayedExcl}
//                                 placeholder='غير شامل'
//                                 readOnly={exclReadOnly || disabled || loading}
//                                 title={taxTitle}
//                                 style={{ cursor: exclReadOnly ? 'not-allowed' : 'text', width: '100%' }}
//                                 onFocus={() => {
//                                   if (exclReadOnly || disabled || loading) return;
//                                   const kf = fieldKey(rowKey, 'excl');
//                                   setPriceInputMap(prev =>
//                                     prev[kf] !== undefined ? prev : { ...prev, [kf]: roundView2(baseExcl).toFixed(2) }
//                                   );
//                                 }}
//                                 onChange={e => {
//                                   if (exclReadOnly || disabled || loading) return;

//                                   const kf = fieldKey(rowKey, 'excl');
//                                   const raw = clampDecimals(e.target.value, 6);
//                                   setPriceInputMap(prev => ({ ...prev, [kf]: raw }));

//                                   const num = raw === '' || raw === '.' ? Number(roundView2(baseExcl)) : Number(raw);
//                                   const excl = Number.isFinite(num) ? roundStore6(num) : roundStore6(baseExcl);

//                                   setDraftMap(prev => ({ ...prev, [rowKey]: excl }));
//                                 }}
//                                 onBlur={() => {
//                                   if (exclReadOnly || disabled || loading) return;

//                                   const kf = fieldKey(rowKey, 'excl');
//                                   const raw = clampDecimals(priceInputMap[kf] ?? roundView2(baseExcl).toFixed(2), 6);
//                                   const num = raw === '' || raw === '.' ? Number(roundView2(baseExcl)) : Number(raw);
//                                   const excl = Number.isFinite(num) ? roundStore6(num) : roundStore6(baseExcl);

//                                   setDraftMap(prev => ({ ...prev, [rowKey]: excl }));

//                                   setPriceInputMap(prev => {
//                                     const next = { ...prev };
//                                     delete next[kf];
//                                     return next;
//                                   });
//                                 }}
//                               />
//                             </td>

//                             {/* ✅ بيع شامل */}
//                             <td className='align-middle'>
//                               <Form.Control
//                                 className={[priceBaseClass, inclReadOnly ? priceInactiveClass : priceActiveClass].join(
//                                   ' '
//                                 )}
//                                 type='text'
//                                 inputMode='decimal'
//                                 autoComplete='off'
//                                 value={displayedIncl}
//                                 placeholder='شامل'
//                                 readOnly={inclReadOnly || disabled || loading}
//                                 title={taxTitle}
//                                 style={{ cursor: inclReadOnly ? 'not-allowed' : 'text', width: '100%' }}
//                                 onFocus={() => {
//                                   if (inclReadOnly || disabled || loading) return;

//                                   const kf = fieldKey(rowKey, 'incl');
//                                   const inclNow = toInclView(Number(baseExcl), ratePct);
//                                   setPriceInputMap(prev =>
//                                     prev[kf] !== undefined ? prev : { ...prev, [kf]: inclNow.toFixed(2) }
//                                   );
//                                 }}
//                                 onChange={e => {
//                                   if (inclReadOnly || disabled || loading) return;

//                                   const kf = fieldKey(rowKey, 'incl');
//                                   const raw = clampDecimals(e.target.value, 6);
//                                   setPriceInputMap(prev => ({ ...prev, [kf]: raw }));

//                                   const fallbackIncl = toInclView(Number(baseExcl), ratePct);
//                                   const num = raw === '' || raw === '.' ? fallbackIncl : Number(raw);
//                                   const incl = Number.isFinite(num) ? roundView2(num) : fallbackIncl;

//                                   const exclStore = toExclStore(incl, ratePct);
//                                   setDraftMap(prev => ({ ...prev, [rowKey]: exclStore }));
//                                 }}
//                                 onBlur={() => {
//                                   if (inclReadOnly || disabled || loading) return;

//                                   const kf = fieldKey(rowKey, 'incl');
//                                   const fallbackIncl = toInclView(Number(baseExcl), ratePct).toFixed(2);
//                                   const raw = clampDecimals(priceInputMap[kf] ?? fallbackIncl, 6);
//                                   const num = raw === '' || raw === '.' ? Number(fallbackIncl) : Number(raw);
//                                   const incl = Number.isFinite(num) ? roundView2(num) : Number(fallbackIncl);

//                                   const exclStore = toExclStore(incl, ratePct);
//                                   setDraftMap(prev => ({ ...prev, [rowKey]: exclStore }));

//                                   setPriceInputMap(prev => {
//                                     const next = { ...prev };
//                                     delete next[kf];
//                                     return next;
//                                   });
//                                 }}
//                               />
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               ) : loading ? (
//                 <div className='h-100 d-flex align-items-center justify-content-center'>
//                   <div className='spinner-border spinner-border-sm text-theme me-2'></div>
//                   <span className='small text-muted'>جاري تحميل البيانات...</span>
//                 </div>
//               ) : (
//                 <div className='h-100 d-flex align-items-center justify-content-center'>
//                   <NoData />
//                 </div>
//               )}
//             </div>

//             {/* ✅ أزرار التحكم */}
//             <div className='d-flex justify-content-end gap-2 mt-3'>
//               <button className='btn btn-outline-secondary' type='button' onClick={close} disabled={loading}>
//                 إغلاق
//               </button>

//               <button
//                 className='btn btn-theme'
//                 type='button'
//                 onClick={handleSave}
//                 disabled={disabled || loading || !hasChanges || !displayLines.length}
//                 title={!hasChanges ? 'لا توجد تغييرات' : ''}
//               >
//                 {loading ? (
//                   <>
//                     <span className='spinner-border spinner-border-sm me-2'></span>
//                     حفظ...
//                   </>
//                 ) : (
//                   'حفظ'
//                 )}
//               </button>
//             </div>
//           </CardBody>

//           <CardFooter className='small text-muted'>
//             {/* * يتم جلب أسعار البيع عبر <b>lookupItemsWithUomRowsByItemIds</b> ثم تقييد العرض على بنود أمر الشراء فقط.
//           <br />
//           * الحفظ يُرجع فقط العناصر التي تغيّر سعر بيعها (Excl محفوظ 6 أرقام عشرية). */}
//           </CardFooter>
//         </Card>
//       </Loading>
//     </NeatixModal>
//   );
// };

// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;
// export default PurchaseOrderSellPricesModal;

// /* PurchaseOrderSellPricesModal.tsx */
// import { useEffect, useMemo, useRef, useState } from 'react';
// import Decimal from 'decimal.js';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import { CardHeader, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import NoData from '@components/NoData/NoData';
// import NeatixModal from '@components/Modal/NeatixModal';
// import type { ItemsWithUomQueryParams, ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import { lookupItemsWithUomRowsByItemIds, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
// import { useTaxTypeList } from '@hooks/Finance/TaxRate/useTaxTypeList';
// import Loading from '@components/Shared/Loader/Loading';

// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { ntxAPI } from '@API/axiosNeatex';

// type Props = {
//   show: boolean;
//   //   setShow: (v: boolean) => void;
//   setShow: any;

//   /** نفس params اللي في POLines (لا نعمل hook جديد) */
//   params?: ItemsWithUomQueryParams;

//   /** نفس itemType اللي في POLines (مثلاً 'Purchasing' أو حسب نظامكم) */
//   priceListId: string | null;

//   /** بنود أمر الشراء */
//   poLines: any[];

//   /** عند الحفظ: نرجّع فقط التغييرات */
//   onSave?: (changes: any[]) => Promise<void> | void;

//   /** تعطيل حفظ/تحميل من الخارج (اختياري) */
//   disabled?: boolean;
// };

// type PriceMode = 'excl' | 'incl';

// const D = (v: Decimal.Value) => new Decimal(v ?? 0);
// const roundView2 = (n: Decimal.Value) => D(n).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
// const roundStore6 = (n: Decimal.Value) => D(n).toDecimalPlaces(6, Decimal.ROUND_HALF_UP).toNumber();

// const clampDecimals = (value: string, maxDec = 6) => {
//   let s = (value ?? '').replace(',', '.').replace(/[^\d.]/g, '');
//   if (s.startsWith('.')) s = `0${s}`;

//   const parts = s.split('.');
//   const intPart = parts[0] ?? '';
//   const decPart = parts.slice(1).join('');

//   if (parts.length === 1) return intPart;
//   return `${intPart}.${decPart.slice(0, maxDec)}`;
// };

/* PurchaseOrderSellPricesModal.tsx */
// import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
// import Decimal from 'decimal.js';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import { CardHeader, Form, InputGroup } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import NoData from '@components/NoData/NoData';
// import NeatixModal from '@components/Modal/NeatixModal';
// import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import { lookupItemsWithUomRowsByItemIds, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
// import { useTaxTypeList } from '@hooks/Finance/TaxRate/useTaxTypeList';
// import Loading from '@components/Shared/Loader/Loading';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { ntxAPI } from '@API/axiosNeatex';

// type Props = {
//   show: boolean;
//   setShow: (v: boolean) => void;
//   priceListId: string | null;
//   poLines: any[];
//   onSave?: (changes: any[]) => Promise<void> | void;
//   disabled?: boolean;
// };

// type PriceMode = 'excl' | 'incl';

// const D = (v: Decimal.Value) => new Decimal(v ?? 0);
// const roundView2 = (n: Decimal.Value) => D(n).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
// const roundStore6 = (n: Decimal.Value) => D(n).toDecimalPlaces(6, Decimal.ROUND_HALF_UP).toNumber();

// const clampDecimals = (value: string, maxDec = 6) => {
//   let s = (value ?? '').replace(',', '.').replace(/[^\d.]/g, '');
//   if (s.startsWith('.')) s = `0${s}`;
//   const parts = s.split('.');
//   const intPart = parts[0] ?? '';
//   const decPart = parts.slice(1).join('');
//   if (parts.length === 1) return intPart;
//   return `${intPart}.${decPart.slice(0, maxDec)}`;
// };

// const toInclView = (excl: number, ratePct: number) => {
//   const factor = D(1).plus(D(ratePct).div(100));
//   return roundView2(D(excl).mul(factor));
// };

// const toExclStore = (incl: number, ratePct: number) => {
//   const factor = D(1).plus(D(ratePct).div(100));
//   if (factor.isZero()) return 0;
//   return roundStore6(D(incl).div(factor));
// };

// const fieldKey = (rowKey: string, mode: PriceMode) => `${rowKey}|${mode}`;

// const getLineUomKey = (line: any) =>
//   String(line?.unitOfMeasure ?? line?.uomCode ?? line?.unitOfMeasureCode ?? line?.uom ?? line?.unitOfMeasureName ?? '');

// const getLinePurchasePrice = (line: any) => {
//   const n = Number(line?.unitPrice ?? line?.purchasePrice ?? line?.price ?? line?.unitCost ?? 0);
//   return Number.isFinite(n) ? n : 0;
// };

// const getRowSellExcl = (r: any) => {
//   const n = Number(r?.unitPrice ?? r?.sellPriceExcl ?? r?.sellPrice ?? r?.salesPrice ?? 0);
//   return Number.isFinite(n) ? n : 0;
// };

// const getRowTaxCategory = (r: any) => {
//   const raw = String(r?.tax ?? r?.taxCategory ?? '').trim();
//   return raw ? raw.toUpperCase() : 'STANDARD';
// };

// const same6 = (a: number, b: number) => roundStore6(a) === roundStore6(b);

// const PurchaseOrderSellPricesModal = ({ show, setShow, priceListId, poLines, onSave, disabled }: Props) => {
//   //   const { t, i18n } = useTranslation();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const abortRef = useRef<AbortController | null>(null);

//   const [loading, setLoading] = useState(false);
//   const [loadError, setLoadError] = useState<any>(null);
//   const [editInclVat, setEditInclVat] = useState(true);

//   const [rows, setRows] = useState<ItemWithUomRow[]>([]);
//   const detailsMap = useMemo(() => {
//     const m = new Map<string, ItemWithUomRow>();
//     (rows ?? []).forEach(r => {
//       if (!r?.itemId || !r?.unitOfMeasure) return;
//       m.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
//     });
//     return m;
//   }, [rows]);

//   const { taxList } = useTaxTypeList('Sales');
//   const taxRateMap = useMemo(() => {
//     const m: Record<string, number> = {};
//     (taxList ?? []).forEach((x: any) => {
//       const cat = String(x?.taxCategory ?? '').toUpperCase();
//       const rate = Number(x?.taxRate);
//       if (cat) m[cat] = Number.isFinite(rate) ? rate : 0;
//     });
//     return m;
//   }, [taxList]);

//   const getItemTaxRatePct = useCallback(
//     (r: any) => {
//       const cat = getRowTaxCategory(r);
//       const found = taxRateMap[cat];
//       if (Number.isFinite(found)) return found;
//       return cat === 'STANDARD' ? 15 : 0;
//     },
//     [taxRateMap]
//   );

//   const [initialMap, setInitialMap] = useState<Record<string, number>>({});
//   const [draftMap, setDraftMap] = useState<Record<string, number>>({});
//   const [priceInputMap, setPriceInputMap] = useState<Record<string, string>>({});

//   const displayLines = useMemo(() => {
//     const list = (poLines ?? []).filter(l => !!l?.itemId);
//     const withDetails = list.map(line => {
//       const uomKey = getLineUomKey(line);
//       const k = makeDetailsKey(line.itemId, uomKey);
//       let det = detailsMap.get(k);

//       if (!det && (line?.unitOfMeasureId || line?.uomId)) {
//         const targetId = String(line?.unitOfMeasureId ?? line?.uomId);
//         det = rows.find(
//           r =>
//             String(r?.itemId) === String(line.itemId) &&
//             String((r as any)?.uomId ?? (r as any)?.unitOfMeasureId) === targetId
//         );
//       }
//       return { line, details: det, key: k };
//     });

//     // تطبيق الفلتر (البحث)
//     if (!searchTerm.trim()) return withDetails;
//     return withDetails.filter(item => {
//       const name = String(item.details?.name2 ?? item.line?.name2 ?? '').toLowerCase();
//       const code = String(item.details?.itemCode ?? item.line?.itemCode ?? '').toLowerCase();
//       return name.includes(searchTerm.toLowerCase()) || code.includes(searchTerm.toLowerCase());
//     });
//   }, [poLines, detailsMap, rows, searchTerm]);

//   const hasChanges = useMemo(() => {
//     return Object.keys(draftMap).some(k => !same6(draftMap[k], initialMap[k]));
//   }, [draftMap, initialMap]);

//   useEffect(() => {
//     if (!show) return;
//     setLoadError(null);
//     setSearchTerm('');

//     abortRef.current?.abort();
//     abortRef.current = new AbortController();

//     const itemIds = Array.from(new Set((poLines ?? []).map(l => String(l?.itemId ?? '')).filter(Boolean)));
//     if (!itemIds.length) return;

//     (async () => {
//       try {
//         setLoading(true);
//         const fetched = await lookupItemsWithUomRowsByItemIds({
//           params: { PriceListId: priceListId ?? undefined, Scope: 1, WithLastPrice: true },
//           itemType: '',
//           itemIds,
//           opts: { signal: abortRef.current?.signal, cache: true }
//         });

//         setRows(fetched ?? []);
//         const init: Record<string, number> = {};
//         (poLines ?? [])
//           .filter(l => !!l?.itemId)
//           .forEach(l => {
//             const uomKey = getLineUomKey(l);
//             const key = makeDetailsKey(l.itemId, uomKey);
//             const det = fetched?.find(r => makeDetailsKey(r?.itemId, r?.unitOfMeasure) === key);
//             init[key] = det ? roundStore6(getRowSellExcl(det)) : 0;
//           });
//         setInitialMap(init);
//         setDraftMap(init);
//       } catch (e: any) {
//         if (e?.name !== 'AbortError') setLoadError(e);
//       } finally {
//         setLoading(false);
//       }
//     })();
//     return () => abortRef.current?.abort();
//   }, [show, poLines, priceListId]);

//   const close = () => setShow(false);

//   const onSubmit = async () => {
//     if (disabled || !priceListId) return;

//     const changes: any[] = [];
//     displayLines.forEach(({ line, details, key }) => {
//       const next = roundStore6(draftMap[key] ?? 0);
//       const prev = roundStore6(initialMap[key] ?? 0);

//       if (!same6(next, prev)) {
//         changes.push({
//           id: (details as any)?.id ?? (details as any)?.priceListItemId ?? null,
//           itemId: line.itemId,
//           unitOfMeasure: getLineUomKey(line),
//           unitPrice: next,
//           enabledFlag: true
//         });
//       }
//     });

//     setIsSubmitting(true);
//     try {
//       const { data } = await ntxAPI.post('Inv/AddUpdatePriceListItem', { priceListId, priceListItemsList: changes });
//       if (data?.succeeded) {
//         CustomAlert({ action: 'Add', msg: 'تم تحديث الأسعار بنجاح' });
//         await onSave?.(changes);
//         close();
//       } else {
//         CustomAlert({ action: 'Error', msg: data?.message });
//       }
//     } catch (e) {
//       CustomAlert({ action: 'Error', msg: 'خطأ في الاتصال' });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const priceBaseClass = 'form-control form-control-sm text-center border border-2 fw-bold transition-all';
//   const priceActiveClass = 'text-theme border-theme shadow-sm';
//   const priceInactiveClass = 'bg-secondary bg-opacity-25 text-muted border-secondary opacity-75';

//   return (
//     <NeatixModal show={show} setShow={setShow} showHeader={false} bodyClassName='p-0' size='xl'>
//       <Loading loading={loading} error={loadError}>
//         <Card className='w-100 d-flex flex-column' style={{ height: '85vh' }}>
//           <CardHeader className=' bg-opacity-10 py-2'>
//             <div className='d-flex flex-wrap justify-content-between align-items-center gap-2'>
//               <div className='d-flex align-items-center gap-3'>
//                 <h5 className='m-0 text-theme'>
//                   <i className='fa fa-tags me-2'></i>أسعار البيع
//                 </h5>
//                 <InputGroup size='sm' style={{ width: '250px' }}>
//                   <InputGroup.Text className='bg-white1'>
//                     <i className='fa fa-search text-muted'></i>
//                   </InputGroup.Text>
//                   <Form.Control
//                     placeholder='بحث في الأصناف...'
//                     value={searchTerm}
//                     onChange={e => setSearchTerm(e.target.value)}
//                   />
//                 </InputGroup>
//               </div>

//               <div className='d-flex align-items-center gap-3'>
//                 <Form.Check
//                   type='switch'
//                   id='toggle-vat'
//                   label={<span className='small fw-bold'>{editInclVat ? ' شامل الضريبة' : 'غير شامل الضريبة'}</span>}
//                   checked={editInclVat}
//                   onChange={e => setEditInclVat(e.target.checked)}
//                 />
//               </div>
//             </div>
//           </CardHeader>

//           <CardBody className='p-0 flex-grow-1' style={{ overflow: 'hidden' }}>
//             <div className='table-responsive h-100'>
//               <table className='table table-hover align-middle mb-0'>
//                 <thead className='sticky-top bg-theme bg-opacity-25 shadow-sm small text-uppercase text-muted'>
//                   <tr>
//                     <th style={{ width: '40%' }}>الصنف والوحدة</th>
//                     <th className='text-center'>تكلفة الشراء</th>
//                     <th className='text-center' style={{ width: '15%' }}>
//                       البيع (غير شامل)
//                     </th>
//                     <th className='text-center' style={{ width: '15%' }}>
//                       البيع (شامل)
//                     </th>
//                     <th className='text-center'>هامش الربح</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {displayLines.map(({ line, details, key }, idx) => {
//                     const purchase = getLinePurchasePrice(line);
//                     const ratePct = details ? getItemTaxRatePct(details) : 15;
//                     const baseExcl = draftMap[key] ?? 0;
//                     const isModified = !same6(baseExcl, initialMap[key]);

//                     // حساب الهامش
//                     const margin = purchase > 0 ? ((baseExcl - purchase) / purchase) * 100 : 0;

//                     const displayedExcl = priceInputMap[fieldKey(key, 'excl')] ?? roundView2(baseExcl).toFixed(2);
//                     const displayedIncl =
//                       priceInputMap[fieldKey(key, 'incl')] ?? toInclView(baseExcl, ratePct).toFixed(2);

//                     return (
//                       <tr key={key || idx} className={isModified ? 'table-warning bg-opacity-10' : ''}>
//                         <td>
//                           <div className='d-flex justify-content-between'>
//                             <div>
//                               <div className='fw-bold  '>{details?.name2 ?? line?.name2 ?? line?.name ?? '---'}</div>
//                               <div className='small text-muted'>{details?.itemCode ?? line?.itemCode ?? '---'}</div>
//                               {!details && (
//                                 <span className='badge bg-danger-subtle text-danger mt-1' style={{ fontSize: '10px' }}>
//                                   غير معرف في قائمة الأسعار
//                                 </span>
//                               )}
//                             </div>
//                             {/* <span className='badge bg-secondary bg-opacity-10 text-theme align-self-start'>
//                               {getLineUomKey(line)}
//                             </span> */}
//                           </div>
//                         </td>
//                         <td className='text-center fw-bold text-muted'>{purchase.toFixed(2)}</td>

//                         {/* عمود الصافي */}
//                         <td>
//                           <Form.Control
//                             className={`${priceBaseClass} ${editInclVat ? priceInactiveClass : priceActiveClass} ${!editInclVat && isModified ? 'border-warning' : ''}`}
//                             value={displayedExcl}
//                             readOnly={editInclVat || disabled}
//                             onFocus={e => !editInclVat && e.target.select()}
//                             onChange={e => {
//                               const val = clampDecimals(e.target.value);
//                               setPriceInputMap(prev => ({ ...prev, [fieldKey(key, 'excl')]: val }));
//                               setDraftMap(prev => ({ ...prev, [key]: Number(val) || 0 }));
//                             }}
//                             onBlur={() =>
//                               setPriceInputMap(prev => {
//                                 const n = { ...prev };
//                                 delete n[fieldKey(key, 'excl')];
//                                 return n;
//                               })
//                             }
//                           />
//                         </td>

//                         {/* عمود الشامل */}
//                         <td>
//                           <Form.Control
//                             className={`${priceBaseClass} ${!editInclVat ? priceInactiveClass : priceActiveClass} ${editInclVat && isModified ? 'border-warning' : ''}`}
//                             value={displayedIncl}
//                             readOnly={!editInclVat || disabled}
//                             onFocus={e => editInclVat && e.target.select()}
//                             onChange={e => {
//                               const val = clampDecimals(e.target.value);
//                               setPriceInputMap(prev => ({ ...prev, [fieldKey(key, 'incl')]: val }));
//                               setDraftMap(prev => ({ ...prev, [key]: toExclStore(Number(val) || 0, ratePct) }));
//                             }}
//                             onBlur={() =>
//                               setPriceInputMap(prev => {
//                                 const n = { ...prev };
//                                 delete n[fieldKey(key, 'incl')];
//                                 return n;
//                               })
//                             }
//                           />
//                         </td>

//                         <td className={`text-center fw-bold ${margin < 0 ? 'text-danger' : 'text-success'}`}>
//                           {margin.toFixed(1)}%<i className={`fa fa-caret-${margin < 0 ? 'down' : 'up'} ms-1`}></i>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//               {displayLines.length === 0 && (
//                 <div className='p-5'>
//                   <NoData />
//                 </div>
//               )}
//             </div>
//           </CardBody>

//           <CardFooter className=' d-flex justify-content-between align-items-center py-3'>
//             <div className='small'>
//               {hasChanges && (
//                 <span className='text-warning fw-bold animate-pulse'>
//                   <i className='fa fa-save me-1'></i> توجد تعديلات غير محفوظة
//                 </span>
//               )}
//             </div>
//             <div className='d-flex gap-2'>
//               <button className='btn btn-outline-secondary px-4' onClick={close}>
//                 إلغاء
//               </button>
//               <button className='btn btn-theme px-5 fw-bold' disabled={!hasChanges || isSubmitting} onClick={onSubmit}>
//                 {isSubmitting ? (
//                   <>
//                     <span className='spinner-border spinner-border-sm me-2'></span>جاري الحفظ...
//                   </>
//                 ) : (
//                   'حفظ التغييرات'
//                 )}
//               </button>
//             </div>
//           </CardFooter>
//         </Card>
//       </Loading>
//     </NeatixModal>
//   );
// };

// export default PurchaseOrderSellPricesModal;

import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import Decimal from 'decimal.js';
import { Card, CardBody, CardFooter } from '@components/card/card';
import { CardHeader, Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NoData from '@components/NoData/NoData';
import NeatixModal from '@components/Modal/NeatixModal';
import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
import { lookupItemsWithUomRowsByItemIds, makeDetailsKey } from '@pages/INV/lookups/itemsWithUomLookup.logic';
import { useTaxTypeList } from '@hooks/Finance/TaxRate/useTaxTypeList';
import Loading from '@components/Shared/Loader/Loading';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { ntxAPI } from '@API/axiosNeatex';

type Props = {
  show: boolean;
  setShow: (v: boolean) => void;
  priceListId: string | null;
  poLines: any[];
  onSave?: (changes: any[]) => Promise<void> | void;
  disabled?: boolean;
};

type PriceMode = 'excl' | 'incl';

const D = (v: Decimal.Value) => new Decimal(v ?? 0);
const roundView2 = (n: Decimal.Value) => D(n).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
const roundStore6 = (n: Decimal.Value) => D(n).toDecimalPlaces(6, Decimal.ROUND_HALF_UP).toNumber();

const clampDecimals = (value: string, maxDec = 6) => {
  let s = (value ?? '').replace(',', '.').replace(/[^\d.]/g, '');
  if (s.startsWith('.')) s = `0${s}`;
  const parts = s.split('.');
  const intPart = parts[0] ?? '';
  const decPart = parts.slice(1).join('');
  if (parts.length === 1) return intPart;
  return `${intPart}.${decPart.slice(0, maxDec)}`;
};

const toInclView = (excl: number, ratePct: number) => {
  const factor = D(1).plus(D(ratePct).div(100));
  return roundView2(D(excl).mul(factor));
};

const toExclStore = (incl: number, ratePct: number) => {
  const factor = D(1).plus(D(ratePct).div(100));
  if (factor.isZero()) return 0;
  return roundStore6(D(incl).div(factor));
};

const fieldKey = (rowKey: string, mode: PriceMode) => `${rowKey}|${mode}`;

const getLineUomKey = (line: any) =>
  String(line?.unitOfMeasure ?? line?.uomCode ?? line?.unitOfMeasureCode ?? line?.uom ?? line?.unitOfMeasureName ?? '');

const getLinePurchasePrice = (line: any) => {
  const n = Number(line?.unitPrice ?? line?.purchasePrice ?? line?.price ?? line?.unitCost ?? 0);
  return Number.isFinite(n) ? n : 0;
};

const getRowSellExcl = (r: any) => {
  const n = Number(r?.unitPrice ?? r?.sellPriceExcl ?? r?.sellPrice ?? r?.salesPrice ?? 0);
  return Number.isFinite(n) ? n : 0;
};

const getRowTaxCategory = (r: any) => {
  const raw = String(r?.tax ?? r?.taxCategory ?? '').trim();
  return raw ? raw.toUpperCase() : 'STANDARD';
};

const same6 = (a: number, b: number) => roundStore6(a) === roundStore6(b);

const formatFactor = (v: any) => {
  if (v == null || v === '') return '-';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 }).format(n);
};

const PurchaseOrderSellPricesModal = ({ show, setShow, priceListId, poLines, onSave, disabled }: Props) => {
  const { i18n, t } = useTranslation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const abortRef = useRef<AbortController | null>(null);

  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState<any>(null);
  const [editInclVat, setEditInclVat] = useState(true);

  const [rows, setRows] = useState<ItemWithUomRow[]>([]);
  const detailsMap = useMemo(() => {
    const m = new Map<string, ItemWithUomRow>();
    (rows ?? []).forEach(r => {
      if (!r?.itemId || !r?.unitOfMeasure) return;
      m.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
    });
    return m;
  }, [rows]);

  const { taxList } = useTaxTypeList('Sales');
  const taxRateMap = useMemo(() => {
    const m: Record<string, number> = {};
    (taxList ?? []).forEach((x: any) => {
      const cat = String(x?.taxCategory ?? '').toUpperCase();
      const rate = Number(x?.taxRate);
      if (cat) m[cat] = Number.isFinite(rate) ? rate : 0;
    });
    return m;
  }, [taxList]);

  const getItemTaxRatePct = useCallback(
    (r: any) => {
      const cat = getRowTaxCategory(r);
      const found = taxRateMap[cat];
      if (Number.isFinite(found)) return found;
      return cat === 'STANDARD' ? 15 : 0;
    },
    [taxRateMap]
  );

  const [initialMap, setInitialMap] = useState<Record<string, number>>({});
  const [draftMap, setDraftMap] = useState<Record<string, number>>({});
  const [priceInputMap, setPriceInputMap] = useState<Record<string, string>>({});

  const displayLines = useMemo(() => {
    const list = (poLines ?? []).filter(l => !!l?.itemId);
    const withDetails = list.map(line => {
      const uomKey = getLineUomKey(line);
      const k = makeDetailsKey(line.itemId, uomKey);
      let det = detailsMap.get(k);

      if (!det && (line?.unitOfMeasureId || line?.uomId)) {
        const targetId = String(line?.unitOfMeasureId ?? line?.uomId);
        det = rows.find(
          r =>
            String(r?.itemId) === String(line.itemId) &&
            String((r as any)?.uomId ?? (r as any)?.unitOfMeasureId) === targetId
        );
      }
      return { line, details: det, key: k };
    });

    if (!searchTerm.trim()) return withDetails;
    return withDetails.filter(item => {
      const name = String(item.details?.name2 ?? item.line?.name2 ?? '').toLowerCase();
      const code = String(item.details?.itemCode ?? item.line?.itemCode ?? '').toLowerCase();
      return name.includes(searchTerm.toLowerCase()) || code.includes(searchTerm.toLowerCase());
    });
  }, [poLines, detailsMap, rows, searchTerm]);

  const hasChanges = useMemo(() => {
    return Object.keys(draftMap).some(k => !same6(draftMap[k], initialMap[k]));
  }, [draftMap, initialMap]);

  useEffect(() => {
    if (!show) return;
    setLoadError(null);
    setSearchTerm('');

    abortRef.current?.abort();
    abortRef.current = new AbortController();

    const itemIds = Array.from(new Set((poLines ?? []).map(l => String(l?.itemId ?? '')).filter(Boolean)));
    if (!itemIds.length) return;

    (async () => {
      try {
        setLoading(true);
        const fetched = await lookupItemsWithUomRowsByItemIds({
          params: { PriceListId: priceListId ?? undefined, Scope: 1, WithLastPrice: true },
          itemType: '',
          itemIds,
          opts: { signal: abortRef.current?.signal, cache: true }
        });

        setRows(fetched ?? []);
        const init: Record<string, number> = {};
        (poLines ?? [])
          .filter(l => !!l?.itemId)
          .forEach(l => {
            const uomKey = getLineUomKey(l);
            const key = makeDetailsKey(l.itemId, uomKey);
            const det = fetched?.find(r => makeDetailsKey(r?.itemId, r?.unitOfMeasure) === key);
            init[key] = det ? roundStore6(getRowSellExcl(det)) : 0;
          });
        setInitialMap(init);
        setDraftMap(init);
      } catch (e: any) {
        if (e?.name !== 'AbortError') setLoadError(e);
      } finally {
        setLoading(false);
      }
    })();

    return () => abortRef.current?.abort();
  }, [show, poLines, priceListId]);

  const close = () => setShow(false);

  const onSubmit = async () => {
    if (disabled || !priceListId) return;

    const changes: any[] = [];
    displayLines.forEach(({ line, details, key }) => {
      const next = roundStore6(draftMap[key] ?? 0);
      const prev = roundStore6(initialMap[key] ?? 0);

      if (!same6(next, prev)) {
        changes.push({
          id: (details as any)?.id ?? (details as any)?.priceListItemId ?? null,
          itemId: line.itemId,
          unitOfMeasure: getLineUomKey(line),
          unitPrice: next,
          enabledFlag: true
        });
      }
    });

    setIsSubmitting(true);
    try {
      const { data } = await ntxAPI.post('Inv/AddUpdatePriceListItem', { priceListId, priceListItemsList: changes });
      if (data?.succeeded) {
        CustomAlert({ action: 'Add', msg: 'تم تحديث الأسعار بنجاح' });
        await onSave?.(changes);
        close();
      } else {
        CustomAlert({ action: 'Error', msg: data?.message });
      }
    } catch (e) {
      CustomAlert({ action: 'Error', msg: 'خطأ في الاتصال' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const priceBaseClass = 'form-control form-control-sm text-center border border-2 fw-bold transition-all';
  const priceActiveClass = 'text-theme border-theme shadow-sm';
  const priceInactiveClass = 'bg-secondary bg-opacity-25 text-muted border-secondary opacity-75';

  return (
    <NeatixModal show={show} setShow={setShow} showHeader={false} bodyClassName='p-0' size='xl'>
      <Loading loading={loading} error={loadError}>
        <Card className='w-100 d-flex flex-column' style={{ height: '85vh' }}>
          <CardHeader className=' bg-opacity-10 py-2'>
            <div className='d-flex flex-wrap justify-content-between align-items-center gap-2'>
              <div className='d-flex align-items-center gap-3'>
                <h5 className='m-0 text-theme'>
                  <i className='fa fa-tags me-2'></i>أسعار البيع
                </h5>

                <InputGroup size='sm' style={{ width: '250px' }}>
                  <InputGroup.Text className='bg-white1'>
                    <i className='fa fa-search text-muted'></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder='بحث في الأصناف...'
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </div>

              <div className='d-flex align-items-center gap-3'>
                <Form.Check
                  type='switch'
                  id='toggle-vat'
                  label={<span className='small fw-bold'>{editInclVat ? ' شامل الضريبة' : 'غير شامل الضريبة'}</span>}
                  checked={editInclVat}
                  onChange={e => setEditInclVat(e.target.checked)}
                />
              </div>
            </div>
          </CardHeader>

          <CardBody className='p-0 flex-grow-1' style={{ overflow: 'hidden' }}>
            <div className='table-responsive h-100'>
              <table className='table table-hover align-middle mb-0'>
                <thead
                  className='sticky-top bg-theme bg-opacity-25 shadow-sm small text-uppercase text-muted'
                  style={{ backdropFilter: 'blur(20px)' }}
                >
                  <tr>
                    <th style={{ width: '40%' }}>الصنف </th>
                    <th className='text-center' style={{ width: '18%' }}>
                      تكلفة الشراء
                      <div className='small text-muted' style={{ fontWeight: 400 }}>
                        (شامل الضريبة)
                      </div>
                    </th>
                    <th className='text-center' style={{ width: '14%' }}>
                      البيع
                      <div className='small text-muted' style={{ fontWeight: 400 }}>
                        (بدون الضريبة)
                      </div>
                    </th>
                    <th className='text-center' style={{ width: '14%' }}>
                      البيع
                      <div className='small text-muted' style={{ fontWeight: 400 }}>
                        (شامل الضريبة)
                      </div>
                    </th>
                    <th className='text-center' style={{ width: '14%' }}>
                      هامش الربح
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {displayLines.map(({ line, details, key }, idx) => {
                    const purchaseExcl = getLinePurchasePrice(line);

                    const ratePct = details ? getItemTaxRatePct(details) : 15;

                    // ✅ تكلفة الشراء شامل الضريبة (عرض فقط)
                    const purchaseIncl = toInclView(purchaseExcl, ratePct);

                    const baseExcl = draftMap[key] ?? 0;
                    const isModified = !same6(baseExcl, initialMap[key]);

                    // ✅ الهامش على أساس (غير شامل) — نفس سلوكك السابق
                    const margin = purchaseExcl > 0 ? ((baseExcl - purchaseExcl) / purchaseExcl) * 100 : 0;

                    const displayedExcl = priceInputMap[fieldKey(key, 'excl')] ?? roundView2(baseExcl).toFixed(2);
                    const displayedIncl =
                      priceInputMap[fieldKey(key, 'incl')] ?? toInclView(baseExcl, ratePct).toFixed(2);

                    // ✅ عرض الوحدة + التعادل
                    const isEn = i18n.language === 'en';
                    const uomLabel =
                      (isEn
                        ? (details as any)?.unitOfMeasureName || (details as any)?.unitOfMeasureName2
                        : (details as any)?.unitOfMeasureName2 || (details as any)?.unitOfMeasureName) ||
                      getLineUomKey(line) ||
                      '---';

                    const uomFactor =
                      (details as any)?.uomFactor ?? (details as any)?.uom_Factor ?? (line as any)?.uomFactor;

                    return (
                      <tr key={key || idx} className={isModified ? 'bg-warning bg-opacity-20' : ''}>
                        <td>
                          <div className='d-flex justify-content-between align-items-start gap-2'>
                            <div style={{ minWidth: 0 }}>
                              <div className='fw-bold'>{details?.name2 ?? line?.name2 ?? line?.name ?? '---'}</div>
                              {/* <div className='small text-muted'>{details?.itemCode ?? line?.itemCode ?? '---'}</div> */}

                              <small className='text-muted d-block'>
                                {t('الوحدة')}: <span className='fw-bold text-theme'>{uomLabel}</span>
                                <span className='mx-2'>•</span>
                                {t('التعادل')}: <span className='fw-bold text-theme'>{uomFactor}</span>
                                <span className='mx-2'>•</span>
                                {t('نسبة الضريبة')}: <span className='fw-bold'>{Number(ratePct || 0).toFixed(0)}%</span>
                              </small>
                            </div>
                          </div>
                        </td>

                        {/* ✅ تكلفة الشراء شامل الضريبة (مع سطر صغير غير شامل) */}
                        <td className='text-center'>
                          <div className='fw-bold text-theme'>{purchaseIncl.toFixed(2)}</div>
                          <div className='small text-muted'>غير شامل: {roundView2(purchaseExcl).toFixed(2)}</div>
                        </td>

                        {/* البيع (غير شامل) */}
                        <td>
                          <Form.Control
                            className={`${priceBaseClass} ${editInclVat ? priceInactiveClass : priceActiveClass} ${
                              !editInclVat && isModified ? 'border-warning' : ''
                            }`}
                            value={displayedExcl}
                            readOnly={editInclVat || disabled}
                            onFocus={e => !editInclVat && e.target.select()}
                            onChange={e => {
                              const val = clampDecimals(e.target.value);
                              setPriceInputMap(prev => ({ ...prev, [fieldKey(key, 'excl')]: val }));
                              setDraftMap(prev => ({ ...prev, [key]: Number(val) || 0 }));
                            }}
                            onBlur={() =>
                              setPriceInputMap(prev => {
                                const n = { ...prev };
                                delete n[fieldKey(key, 'excl')];
                                return n;
                              })
                            }
                          />
                        </td>

                        {/* البيع (شامل) */}
                        <td>
                          <Form.Control
                            className={`${priceBaseClass} ${!editInclVat ? priceInactiveClass : priceActiveClass} ${
                              editInclVat && isModified ? 'border-warning' : ''
                            }`}
                            value={displayedIncl}
                            readOnly={!editInclVat || disabled}
                            onFocus={e => editInclVat && e.target.select()}
                            onChange={e => {
                              const val = clampDecimals(e.target.value);
                              setPriceInputMap(prev => ({ ...prev, [fieldKey(key, 'incl')]: val }));
                              setDraftMap(prev => ({ ...prev, [key]: toExclStore(Number(val) || 0, ratePct) }));
                            }}
                            onBlur={() =>
                              setPriceInputMap(prev => {
                                const n = { ...prev };
                                delete n[fieldKey(key, 'incl')];
                                return n;
                              })
                            }
                          />
                        </td>

                        <td className={`text-center fw-bold ${margin < 0 ? 'text-danger' : 'text-success'}`}>
                          {margin.toFixed(1)}%<i className={`fa fa-caret-${margin < 0 ? 'down' : 'up'} ms-1`}></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {displayLines.length === 0 && (
                <div className='p-5'>
                  <NoData />
                </div>
              )}
            </div>
          </CardBody>

          <CardFooter className=' d-flex justify-content-between align-items-center py-3'>
            <div className='small'>
              {hasChanges && (
                <span className='text-warning fw-bold animate-pulse'>
                  <i className='fa fa-save me-1'></i> توجد تعديلات غير محفوظة
                </span>
              )}
            </div>

            <div className='d-flex gap-2'>
              <button className='btn btn-outline-secondary px-4' onClick={close}>
                إلغاء
              </button>
              <button className='btn btn-theme px-5 fw-bold' disabled={!hasChanges || isSubmitting} onClick={onSubmit}>
                {isSubmitting ? (
                  <>
                    <span className='spinner-border spinner-border-sm me-2'></span>جاري الحفظ...
                  </>
                ) : (
                  'حفظ التغييرات'
                )}
              </button>
            </div>
          </CardFooter>
        </Card>
      </Loading>
    </NeatixModal>
  );
};

export default PurchaseOrderSellPricesModal;
